import type { MappedCustomDataServiceObjectField, MappedServiceObjectData } from 'common/models';
import { useCustomTranslation } from 'helpers/translationHelper';
import type { ServiceObjectInCustomer } from 'pages/serviceObjects/models';
import React from 'react';

import ServiceObjectTableColumn from './ServiceObjectTableColumn';

interface OwnProps {
  serviceObjects: ServiceObjectInCustomer[];
  data: MappedServiceObjectData[];
}

const ServiceObjectTable = (props: OwnProps) => {
  const { data, serviceObjects } = props;

  const { t } = useCustomTranslation();

  // Checklist is unsupported field
  const filteredData = data.filter((x) => x.fieldData?.formField.type !== 'CheckList');

  return (
    <table>
      <thead>
        <tr>
          <td>{t('customData.serviceObjects.name')}</td>
          {filteredData.map((reportData) => (
            <td key={reportData.fieldData?.id || reportData.properties?.label}>
              {reportData.type === 'FormField'
                ? reportData.fieldData?.label
                : reportData.properties?.label}
            </td>
          ))}
        </tr>
      </thead>
      <tbody>
        {serviceObjects.map((serviceObject) => {
          return (
            <tr key={serviceObject.id} className="data-row">
              <td>{serviceObject.name}</td>
              {filteredData.map((reportData) => {
                const relatedFieldValue = reportData.values?.find(
                  (x) => x.serviceObjectId === serviceObject.id
                )?.value;

                return (
                  <td
                    key={`${serviceObject.id}-${
                      reportData.fieldData?.id || reportData.properties?.label || ''
                    }`}
                  >
                    {reportData.type === 'FormField' ? (
                      <ServiceObjectTableColumn
                        fieldData={reportData.fieldData as MappedCustomDataServiceObjectField}
                        serviceObjectId={serviceObject.id}
                      />
                    ) : (
                      <span>{relatedFieldValue || ''}</span>
                    )}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ServiceObjectTable;
